import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

const TRIAL_CONVERSION_REFETCH_MS = 10_000;

export interface UnconvertedTrialFamily {
  familyKey: string;
  displayName: string;
  email: string;
  contactId?: string;
}

export interface TrialConversionResponse {
  totalFamilies: number;
  convertedFamilies: number;
  conversionRate: number;
  unconvertedFamilies: UnconvertedTrialFamily[];
}

export interface TrialConversionParams {
  startDate?: string;
  endDate?: string;
  dateField?: 'startTime' | 'createdAt';
  enabled?: boolean;
  refetchInterval?: number | false;
}

export const getTrialConversionAPI = async (params: TrialConversionParams) => {
  const response = await baseAPI.get<TrialConversionResponse>(
    '/dashboard/metrics/trial-conversion',
    {
      params: {
        startDate: params.startDate,
        endDate: params.endDate,
        dateField: params.dateField,
      },
    },
  );
  return response.data;
};

export const useGetTrialConversion = (params: TrialConversionParams) => {
  const { enabled = true, refetchInterval, ...apiParams } = params;
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [
      KEYS.TRIAL_CONVERSION,
      apiParams.startDate,
      apiParams.endDate,
      apiParams.dateField,
    ],
    queryFn: () => getTrialConversionAPI(apiParams),
    enabled: enabled && Boolean(apiParams.startDate && apiParams.endDate),
    refetchInterval: refetchInterval ?? TRIAL_CONVERSION_REFETCH_MS,
  });
};
